export const materialTypes = {
    EMISSION: 'emission',
    HEAT: 'chauffage',
    COLD: 'froid',
};
